module.exports = __webpack_public_path__ + "static/header-image-mobile@2x-8a9f1a87aa01a25b8ed124e66196c5e8.png";